import { httpService } from "../httpService.service";

// Backend contract — F-07 IP completeness score & F-08 PM nudge tool.
// stageBand: 1=Planning | 2=Implementation | 3=Reporting | 4=Closed.
// breakdown: { requiredFieldsScore, visitsScore, trackingScore, flagsScore, *Max }.

// F-07 — completeness for a single IP plan.
export const getIPCompleteness = (ipPlanId, callback, errCallback) =>
  httpService.get(
    `/api/IPPlan/getIPCompleteness?ipPlanId=${ipPlanId}`,
    callback,
    errCallback
  );

// F-07 — completeness for every IP plan in a project, laggards-first.
export const getProjectIPCompleteness = (projectId, callback, errCallback) =>
  httpService.get(
    `/api/IPPlan/getProjectIPCompleteness?projectId=${projectId}`,
    callback,
    errCallback
  );

// F-08 — nudge preview. Returns
// { iPPlanId, assigneeId, assigneeName, assigneeEmail, missingFields[], preFilledMessage }.
export const getNudgePreview = (ipPlanId, callback, errCallback) =>
  httpService.get(
    `/api/IPPlan/getNudgePreview?ipPlanId=${ipPlanId}`,
    callback,
    errCallback
  );

// F-08 — send the nudge. Body { iPPlanId, customMessage? }. PM/Admin only.
export const nudgeAssignee = (iPPlanId, customMessage, callback, errCallback) =>
  httpService.post(
    `/api/IPPlan/nudgeAssignee`,
    { iPPlanId, customMessage },
    callback,
    errCallback
  );
